import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import Icon, { IconProps } from '../Icon';

interface ThemeType {
  color: {
    grey: {
      [key: number]: string;
    };
  };
}

const AddIcon: React.FC<IconProps> = ({ color }) => {
  const { color: themeColor } = useContext(ThemeContext as React.Context<ThemeType>);
  return (
    <Icon color="#6EBD70">
      <svg height="24" viewBox="0 0 24 24" width="24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="#6EBD70" />
      </svg>
    </Icon>
  );
};

export default AddIcon;
